import { Component, Input } from '@angular/core';
import { TranslateService }  from '@ngx-translate/core';
import { NgbActiveModal }    from '@ng-bootstrap/ng-bootstrap';
import { UIRouter }          from '@uirouter/angular';

import { ApiService }      from '../api/api.service';
import { ConfirmService }  from '../messages/confirm/confirm.service';
import { MessagesService } from '../messages/messages.service';
import { VehicleModel }    from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-follow-up-notes',
  template: require('./vehicle.follow-up-notes.component.html')
})
export class VehicleFollowUpNotesComponent {
  @Input() reference: string;
  @Input() vehicle  : VehicleModel;
  @Input() view     : string;

  constructor (
    public  activeModal     : NgbActiveModal,
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  addNotesToJobCard () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.ADD_FOLLOW_UP_NOTES'))
    .then(() => this.apiService.post(
      this.view === 'event'
        ? '/event/add_follow_up_notes_to_job_card'
        : '/invoice/add_follow_up_notes_to_job_card',
      {
        comment     : this.vehicle.follow_up_comment,
        date        : this.vehicle.follow_up_date,
        reference_id: this.reference
      },
      'follow_up_details'
    ))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.CREATED.FOLLOW_UP_NOTES'), 'success');
      this.router.stateService.reload();
      this.activeModal.close();
    })
    .catch(( err ) => this.messagesService.error(err));
  }

  clearFollowUpNotes () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.CLEAR_FOLLOW_UP_NOTES'))
    .then(() => this.apiService.get('/vehicles/clear_vehicle_follow_up_note', this.vehicle.id))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.FOLLOW_UP_NOTES'), 'success');
      this.router.stateService.reload();
      this.activeModal.close();
    })
    .catch(( err ) => this.messagesService.error(err));
  }
}
